import { Buffer } from '@stacks/common';
import { ClarityType } from '../clarityValue';
const bufferCV = (buffer) => {
    if (buffer.length > 1000000) {
        throw new Error('Cannot construct clarity buffer that is greater than 1MB');
    }
    return { type: ClarityType.Buffer, buffer };
};
const bufferCVFromString = (str) => bufferCV(Buffer.from(str));
export { bufferCV, bufferCVFromString };
//# sourceMappingURL=bufferCV.js.map